import { useEffect, useState } from 'react'
import { usePagination } from '@table-library/react-table-library/pagination'
import axios from 'axios'
import { useTheme } from '@table-library/react-table-library/theme'
import {
  DEFAULT_OPTIONS,
  getTheme,
} from '@table-library/react-table-library/material-ui'
import { Stack, TextField } from '@mui/material'

import { TABLE_THEME, SERVER_URL } from '../../../constants'
import Button from '../../../components/Button'
import ManageTable from './ManageTable'

function ManageSalesByItem() {
  const [isLoading, setIsLoading] = useState(false)

  let today = new Date()

  const [fromInput, setFromInput] = useState('2022-10-01')
  const [toInput, setToInput] = useState(
    today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate(),
  )

  const [storedData, setStoredData] = useState({ nodes: [] })
  const [displayedData, setDisplayedData] = useState({ nodes: [] })

  useEffect(() => {
    renderTable()
  }, [])

  const columns = [
    { label: 'Name', renderCell: (item) => item.name },
    { label: 'Amount Sold', renderCell: (item) => item.count },
    {
      label: 'Total Price',
      renderCell: (item) => Math.round(item.sum * 100) / 100,
    },
  ]

  const materialTheme = getTheme(DEFAULT_OPTIONS)
  const COLUMN_THEME = {
    Table: `
      --data-table-library_grid-template-columns: 34% 33% 33%;
    `,
  }
  const theme = useTheme([materialTheme, TABLE_THEME, COLUMN_THEME])

  const pagination = usePagination(displayedData, {
    state: {
      page: 0,
      size: 5,
    },
  })

  async function renderTable() {
    setIsLoading(true)

    let salesRes = await axios.get(
      `${SERVER_URL}/sales/item/${fromInput}/${toInput}`,
    )

    if (salesRes) {
      setDisplayedData({ nodes: salesRes.data })
      setStoredData({ nodes: salesRes.data })
    }

    setIsLoading(false)
  }

  return (
    <>
      <ManageTable
        searchProps={{
          name: 'Menu Items',
          property: 'name',
          data: storedData,
          setData: setDisplayedData,
        }}
        columns={columns}
        displayedData={displayedData}
        theme={theme}
        pagination={pagination}
      />

      <Stack direction="row" spacing={2}>
        <TextField
          id="from-field"
          label="From"
          fullWidth
          placeholder={'YYYY-MM-DD'}
          InputLabelProps={{ shrink: true }}
          onChange={(event) =>
            event.target.value
              ? setFromInput(event.target.value)
              : setFromInput('2022-10-01')
          }
        />

        <TextField
          id="to-field"
          label="To"
          fullWidth
          placeholder={'YYYY-MM-DD'}
          InputLabelProps={{ shrink: true }}
          onChange={(event) =>
            event.target.value
              ? setToInput(event.target.value)
              : setToInput(
                  today.getFullYear() +
                    '-' +
                    (today.getMonth() + 1) +
                    '-' +
                    today.getDate(),
                )
          }
        />

        <Button
          size="lg"
          fullWidth
          isLoading={isLoading}
          onClick={() => renderTable()}
        >
          Render Table
        </Button>
      </Stack>
    </>
  )
}

export default ManageSalesByItem
